export default class Title extends Phaser.Image {
  constructor({ game, title }) {
    super(game);

    this.loadTexture(Title.SPRITESHEET, title);
  }
}

Title.SPRITESHEET = 'titles';
Title.HELLO = 'title_hello';
Title.HOWTOPLAY = 'title_howtoplay';
Title.JOINED_GNASHER = 'title_joined_gnasher';
Title.JOINED_GNIPPER = 'title_joined_gnipper';
Title.JOINED_ROBOTODOG = 'title_joined_robotdog';
Title.JOINED_RUBI = 'title_joined_rubi';
Title.OHNO = 'title_ohno';
Title.WELLDONE = 'title_welldone';
Title.YOUDIDIT = 'title_youdidit';
